var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.layoutComponent,{tag:"component",attrs:{"field":_vm.field,"errors":_vm.errors}},[_c('template',{slot:"field"},[_c('editor',{staticClass:"editor-field",attrs:{"options":_vm.options},model:{value:(_vm.fieldValue),callback:function ($$v) {_vm.fieldValue=$$v},expression:"fieldValue"}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }